(function () {
    var doc = document.documentElement;
    var w = window;

    var prevScroll = w.scrollY || doc.scrollTop;
    var curScroll;
    var direction = 0;
    var prevDirection = 0;

    var header = document.getElementById("site-header");

    var checkScroll = function () {
        /*
         ** Find the direction of scroll
         ** 0 - initial, 1 - up, 2 - down
         */

        curScroll = w.scrollY || doc.scrollTop;
        if (curScroll > prevScroll) {
            //scrolled up
            direction = 2;
        } else if (curScroll < prevScroll) {
            //scrolled down
            direction = 1;
        }

        if (direction !== prevDirection) {
            toggleHeader(direction, curScroll);
        }

        prevScroll = curScroll;
    };

    var toggleHeader = function (direction, curScroll) {
        if (direction === 2 && curScroll > 70) {

            header.classList.add("show-header");
            prevDirection = direction;
        } else if (direction === 1 && curScroll < 70) {
            header.classList.remove("show-header");
            prevDirection = direction;
        }
    };

    window.addEventListener("scroll", checkScroll);
})();

// for service box

function changeActiveService(serviceId) {
    const serviceButtons = document.querySelectorAll('.home-services_box');
    serviceButtons.forEach(serviceButton => {
        serviceButton.classList.remove('active');
    });

    const serviceContents = document.querySelectorAll('.home-services_content, .d-lg-none');
    serviceContents.forEach(serviceContent => {
        serviceContent.classList.remove('active');
        serviceContent.style.display = 'none';
    });

    const selectedServiceButton = document.querySelector(`.service-${serviceId}`);
    selectedServiceButton.classList.add('active');

    const selectedServiceContents = document.querySelectorAll(`.service-content-${serviceId}`);
    selectedServiceContents.forEach(selectedServiceContent => {
        selectedServiceContent.classList.add('active');
        selectedServiceContent.style.display = 'block';
    });
}


// Fügen Sie EventListener für alle Service-Buttons hinzu
const serviceButtons = document.querySelectorAll('.home-services_box');
serviceButtons.forEach(serviceButton => {
    serviceButton.addEventListener('click', () => {
        changeActiveService(serviceButton.dataset.serviceId);
    });
});

// Versteckt alle Service-Inhalte außer dem ersten beim Laden der Seite
window.addEventListener('DOMContentLoaded', () => {
    const serviceContents = document.querySelectorAll('.home-services_content');
    serviceContents.forEach((serviceContent, index) => {
        if (index !== 0) {
            serviceContent.style.display = 'none';
        }
    });

    const mobileServiceContents = document.querySelectorAll('.d-lg-none');
    mobileServiceContents.forEach((mobileServiceContent) => {
        if (!mobileServiceContent.classList.contains('service-content-1')) {
            mobileServiceContent.style.display = 'none';
        }
    });
});

window.addEventListener('DOMContentLoaded', () => {
    const path = location.pathname;
    document.querySelectorAll('.main-nav_link').forEach(item => {
        const target = item.getAttribute('data-target');
        if (path === target) {
            item.classList.add('active');
        } else {
            item.classList.remove('active');
        }
    });
});

